import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import "./style.less";

export interface PlotSummaryProps {
  totalPlots: number;
  assigned: number;
  applicationAssigned?: number;
  applicationTotal?: number;
  applicationLabel?: string;
  assignedLabel?: string;
  missingLabel?: string;
  levels?: number;
  levelsValue?: string;
  totalLabel?: string;
  className?: string;
}

interface StatItem {
  key: string;
  label: string;
  value: string | number;
}

const PlotSummary: FC<PlotSummaryProps> = ({
  totalPlots,
  assigned,
  applicationAssigned = 0,
  applicationTotal = 0,
  applicationLabel,
  assignedLabel,
  missingLabel,
  levels,
  levelsValue,
  totalLabel,
  className,
}) => {
  const { t } = useTranslation();
  const missing = totalPlots - assigned;

  const stats: StatItem[] = [
    {
      key: "totalPlots",
      label:
        totalLabel ??
        formatTranslation(t("newRatesAndDosage.plotSummary.totalPlots")),
      value: totalPlots,
    },
    {
      key: "assigned",
      label:
        assignedLabel ??
        formatTranslation(t("newRatesAndDosage.plotSummary.assigned")),
      value: assigned,
    },
    {
      key: "missing",
      label:
        missingLabel ??
        formatTranslation(t("newRatesAndDosage.plotSummary.missing")),
      value: missing,
    },
    levels === undefined
      ? {
          key: "application",
          label:
            applicationLabel ??
            formatTranslation(t("newRatesAndDosage.plotSummary.application")),
          value: `${applicationAssigned}/${applicationTotal}`,
        }
      : {
          key: "levels",
          label: formatTranslation(t("newRatesAndDosage.plotSummary.levels")),
          value: levelsValue ?? levels,
        },
  ];

  return (
    <div
      className={`rd-plot-summary ${className ?? ""}`}
      data-testid="plot-summary"
    >
      {stats.map((stat) => (
        <div key={stat.key} className="rd-plot-summary__item">
          <span
            className="rd-plot-summary__value"
            data-testid={`plot-summary-value-${stat.key}`}
          >
            {stat.value}
          </span>
          <span className="rd-plot-summary__label">{stat.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PlotSummary;
